
import { defineComponent, ref, getCurrentInstance, computed } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';


export default defineComponent({
  components: {
    vanActionSheet: ActionSheet,
  },
  setup(_, context) {
    const { proxy } = getCurrentInstance() as { proxy: any }

    const show = ref(true);

    const handleClose = ({ button_type }: Record<string, string>) => {

      show.value = false;
      setTimeout(() => {
        context.emit('close', { button_type });
      }, 500);
    };

    const titleWords = computed(() => {
      return proxy.$root.$t('get_the_full_experience_on_KWAI').replace('${0}', proxy.$appName)
    })

    const installWords = computed(() => {
      return proxy.$root.$t('k_326747').replace('${0}', proxy.$appName)
    })

    const handleConfirm = () => {
      context.emit('confirm', { button_type: 'main', skip_to: 'app' });
    };

    return {
      show,
      installWords,
      titleWords,
      handleClose,
      handleConfirm,
    };
  },
});
